import script from "./PortoDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PortoDetail.vue?vue&type=script&setup=true&lang=js"

import "./PortoDetail.vue?vue&type=style&index=0&id=462898f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462898f8"]])

export default __exports__